const MENU_CURATION_TASK_ENTITY_LINK_ORIGIN_TYPE = {
  DISH: 'dish',
  MENU_TITLE: 'menuTitle',
}

export default MENU_CURATION_TASK_ENTITY_LINK_ORIGIN_TYPE
